module.exports = __webpack_public_path__ + "img/dropshipping_blue.b2bd1741.svg";